export function stripeStyles(theme) {
  return {
    theme: 'stripe',
    labels: 'above',
    variables: {
      colorPrimary: theme.palette.primary.light,
      colorText: theme.palette.text.primary,
      colorTextSecondary: theme.palette.text.primary,
      fontFamily: theme.stripe.typography.fontFamily,
      spacingGridColumn: '30px',
    },
    rules: {
      '.AccordionItem': {
        fontWeight: 'bold',
        border: `solid 2px ${theme.palette.custom.frame}`,
        fontSize: '18px',
        paddingTop: '33px',
        paddingBottom: '33px',
        paddingLeft: '33px',
        paddingRight: '33px',
        '-webkit-text-fill-color': theme.palette.custom.black,
      },
      '.TabIcon': {
        fill: theme.palette.custom.white,
        paddingRight: '12px',
      },
      '.Label': {
        marginLeft: '10px',
      },
      '.Input': {
        borderRadius: '10px',
        border: `1px solid ${theme.palette.custom.black}`,
        lineHeight: '27px',
      },
      '.Input:focus': {
        borderColor: theme.palette.custom.black,
        boxShadow: `0 0 10px ${theme.palette.custom.f1InputHighlight}`,
      },
      '.Error': {
        fontFamily: 'Formula1-Regular',
        fontSize: '12px',
        letterSpacing: '.5px',
        fontWeight: 500,
      },
      '.Input::placeholder': {
        '-webkit-text-fill-color': 'transparent',
      },
      '.Input--empty': { color: theme.palette.text.primary },
    },
  };
}
